module.exports = __webpack_public_path__ + "static/media/navBarIconFabricCalc.93186ddd.svg";